import _ from 'underscore';
import { CampaignType as AccountLevelCampaignType } from '@bingads-webui-campaign/campaign-ui-common';

const CampaignLevelCampaignType = _.mapObject(AccountLevelCampaignType, (__, key) => key);

// For card level preference, we should always use getCardPreferenceWithDefault to make sure we can fallback to default value
// we now should only use this to try to get page level preference
export const getPreference = ({
  key,
  preference,
}) => {
  // In fluent overview page, we always use user level preference, if we need to load legacy preference, we need add scope info
  // to figure out the correct preference level.
  const preferenceObj = preference.findByNameAtUserLevel(key);

  return _.get(preferenceObj, 'Data');
};

export const getPreferencePatcher = ({
  key,
  preference,
}) => (update) => {
  const preferenceData = getPreference({ key, preference });
  const newPreferenceData = {
    ...preferenceData,
    ...update,
  };

  preference.setAtUserLevel({
    Data: newPreferenceData,
    Name: key,
  });
};

function getPreferenceKeyPrefix({
  navigationLevel,
  campaignType,
}) {
  let campaignTypeString = 'other';
  if (campaignType === CampaignLevelCampaignType.Hotel || campaignType === AccountLevelCampaignType.Hotel) {
    campaignTypeString = 'hotel';
  } else if (campaignType === CampaignLevelCampaignType.PerformanceMax || campaignType === AccountLevelCampaignType.PerformanceMax) {
    campaignTypeString = 'pmax';
  } else if (campaignType === CampaignLevelCampaignType.App || campaignType === AccountLevelCampaignType.App) {
    campaignTypeString = 'app';
  } else if (campaignType === CampaignLevelCampaignType.LinkedIn || campaignType === AccountLevelCampaignType.LinkedIn) {
    campaignTypeString = 'linkedin';
  }

  return `OverviewPage-${navigationLevel}-${campaignTypeString}`;
}

export const getCardPreferenceKey = ({
  cardTypeId,
  navigationLevel,
  campaignType,
}) => {
  const prefix = getPreferenceKeyPrefix({ navigationLevel, campaignType });

  return `${prefix}-${cardTypeId}`;
};

export const getPagePreferenceKey = ({
  navigationLevel,
  campaignType,
}) => {
  const prefix = getPreferenceKeyPrefix({ navigationLevel, campaignType });
  return `${prefix}-PageData`;
};

// This is not a pure function, we may need to clean up the preference store(set defualt value) if current preference is not valid
export const getCardPreferenceWithDefault = ({
  config,
  navigationLevel,
  campaignType,
  preference,
  permissions,
}) => {
  const cardPreferenceKey = getCardPreferenceKey({
    cardTypeId: config.typeId,
    navigationLevel,
    campaignType,
  });
  let originCardPreference = getPreference({
    key: cardPreferenceKey,
    preference,
  });
  const defaultPreference = config.getDefaultPreference ? config.getDefaultPreference({
    permissions,
  }) : undefined;

  if (originCardPreference && _.isFunction(config.isPreferenceValid) && !config.isPreferenceValid({
    cardPreference: originCardPreference,
    permissions,
    campaignType,
  })) {
    originCardPreference = null;
    if (defaultPreference) {
      const patchPreference = getPreferencePatcher({
        key: cardPreferenceKey,
        preference,
      });
      patchPreference(defaultPreference);
    }
  }

  const cardPreference = (originCardPreference || defaultPreference)
    ? _.defaults(originCardPreference, defaultPreference)
    : undefined;

  return cardPreference;
};

export const getCardPreferenceOptionsForDfm = ({
  config,
  navigationLevel,
  campaignType,
  preference,
  permissions,
}) => {
  const cardPreference = getCardPreferenceWithDefault({
    config,
    navigationLevel,
    campaignType,
    preference,
    permissions,
  });

  let options = cardPreference;
  if (options && config.getDfmPreferenceObject) {
    options = config.getDfmPreferenceObject(cardPreference);
  }

  return {
    id: config.typeId,
    options,
  };
};
